import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { caseStudiesPage } from "@/content/site";
import { caseFilters, caseStudyCards } from "@/content/caseStudies";
import usePageMeta from "@/hooks/usePageMeta";
import { PageHero } from "@/components/sections/PageHero";
import { CtaBand } from "@/components/sections/CtaBand";
import { CaseCard } from "@/components/sections/CaseCard";
import { CaseModal } from "@/components/sections/CaseModal";
import { getLenis } from "@/components/layout/SmoothScroll";
import { FilterTabs } from "@/components/common/FilterTabs";

const IDS = caseFilters.map((f) => f.id);
const countFor = (id) => (id === "all" ? caseStudyCards.length : caseStudyCards.filter((c) => c.category === id).length);

export default function CaseStudies() {
  usePageMeta(caseStudiesPage.meta);
  const [params, setParams] = useSearchParams();
  const active = IDS.includes(params.get("filter")) ? params.get("filter") : "all";
  const [selected, setSelected] = useState(null);
  const list = active === "all" ? caseStudyCards : caseStudyCards.filter((c) => c.category === active);

  useEffect(() => {
    const lenis = getLenis();
    if (selected) lenis?.stop();
    else lenis?.start();
  }, [selected]);

  const select = (id) => setParams(id === "all" ? {} : { filter: id }, { replace: true });

  return (
    <>
      <PageHero hero={caseStudiesPage.hero} testId="case-studies-hero" />
      <section className="pb-24 sm:pb-32" data-testid="case-studies-section">
        <div className="container-x">
          <FilterTabs filters={caseFilters} active={active} onSelect={select} countFor={countFor} label="Filter case studies" testIdPrefix="case" />
          <motion.div layout className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="case-grid">
            <AnimatePresence mode="popLayout" initial={false}>
              {list.map((c) => (
                <CaseCard key={c.id} c={c} onOpen={setSelected} />
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>
      <CaseModal c={selected} onClose={() => setSelected(null)} />
      <CtaBand title={caseStudiesPage.cta.title} />
    </>
  );
}
